import * as React from 'react';

import { getTermValue } from '@/packages/JsonQuery';
import { type EPublishPeriod } from '@/packages/api-models/common/json_query';

import { PublicationDate } from '../../../components/advancedFilters/PublicationDate';
import { useFiltersContext } from '../../../utils/context';

export const PublicationDateContainer: React.FC = () => {
  const { onChange, jsonQuery } = useFiltersContext();

  const period = getTermValue('publish_period')(jsonQuery);
  const hasPhoto = getTermValue('wp')(jsonQuery);
  const hasVideo = getTermValue('has_video')(jsonQuery);

  const handlePublishPeriodChange = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (period: EPublishPeriod | null) => {
      onChange({ action: 'setPublishPeriod', arguments: [period] });
    },
    [onChange],
  );

  const handleHasVideoChange = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (hasVideo: boolean | null) => {
      onChange({ action: 'setHasVideo', arguments: [hasVideo] });
    },
    [onChange],
  );

  const handleHasPhotoChange = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (hasPhoto: boolean | null) => {
      onChange({ action: 'setHasPhoto', arguments: [hasPhoto] });
    },
    [onChange],
  );

  return (
    <PublicationDate
      hasPhoto={hasPhoto}
      hasVideo={hasVideo}
      publishPeriod={period}
      onHasPhotoChange={handleHasPhotoChange}
      onHasVideoChange={handleHasVideoChange}
      onPublishPeriodChange={handlePublishPeriodChange}
    />
  );
};
